module.exports = __webpack_public_path__ + "img/img5.c75cb968.jpg";